var map = {
	"./altf/awake-bot-avatar.png": "02c8",
	"./datarmony/awake-bot-avatar.png": "bd58",
	"./default/awake-bot-avatar.png": "5cb1",
	"./euruni/awake-bot-avatar.png": "feef",
	"./foundever/awake-bot-avatar.png": "e4f7",
	"./gala/awake-bot-avatar.png": "1c94",
	"./ie/awake-bot-avatar.png": "695d",
	"./sitel-learning-sandbox/awake-bot-avatar.png": "401d",
	"./sitel-learning/awake-bot-avatar.png": "2092"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d364";